<!-- 此component用來分類清單的顯示 -->
<template>
	<div class="category">
		<div class="category-table">
			<!--<div class="hint">您可拖曳排序分類，排序 1-8 的分類會顯示在首頁選單第一列，其餘的分類則隱藏在『更多』中</div>-->
			<el-col class="title-bar" style="display:block;">
				<div class="number-of-categories">{{number}}</div>
				<el-button class="add-btn" @click="handleAdd">新增
					<img src="../../assets/icon/ic_add.png" alt="A" class="add-icon">
				</el-button>
			</el-col>
			<!--<el-table-draggable :animate="300">-->
				<el-table v-loading="listLoading" 
									:data="categories" 
									row-key="id" 
									empty-text="暫無數據" 
									style="display:inline-block; float: left;">
					<!--
					<el-table-column min-width="35%" prop="index" label="排序">
						<template slot-scope="scope">
							<span>{{ scope.row.index }}</span>
						</template>
					</el-table-column>
					-->
					<el-table-column prop="name" label="分類名稱">
						<template slot-scope="scope">
							<el-input v-show="scope.row.isEdit" size="small" v-model="scope.row.title"></el-input>
							<span v-show="!scope.row.isEdit">{{ scope.row.title }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="abbreviation" label="縮寫"> 
						<template slot-scope="scope">
						<!--
							<el-input v-show="scope.row.isEdit" size="small" v-model="scope.row.code"></el-input>
							<span v-show="!scope.row.isEdit">{{ scope.row.code }}</span>
						-->
						<span>{{ scope.row.code }}</span>
						</template>
					</el-table-column>
					<el-table-column>
						<template slot-scope="scope">
							<img v-show="!scope.row.isEdit" src="../../assets/icon/ic_delete_blue.png" alt="D" class="delete-icon" @click="handleDelete(scope.$index, scope.row)">
							<img v-show="!scope.row.isEdit" src="../../assets/icon/ic_edit_blue.png" alt="E" class="edit-icon" @click="handleEdit(scope.$index, scope.row)">
							<el-button v-show="scope.row.isEdit" class="save-btn" size="small" @click="handleSave(scope.$index, scope.row)">儲存</el-button>
							<el-button v-show="scope.row.isEdit" class="cancel-btn" size="small" @click="handleCancel(scope.$index, scope.row)">取消</el-button>
						</template>
					</el-table-column>
				</el-table>
			<!--</el-table-draggable>-->
		</div>

		<alert v-show="alert.display && this.$store.state.nowCategoryStatus === 1" :warning="alert.warning" :content="alert.content" :title="alert.title" @close="closeAlert" @delete="deleteCategory()"></alert>

		<alert v-show="alert.display && this.$store.state.nowCategoryStatus === 2" :placeholder="alert.placeholder" :inputs="alert.inputs" :title="alert.title" @close="closeAlert" @add="addCategory" @changeMaster="changeMaster" @changeSecondary="changeSecondary"></alert>
		
		<hint v-show="hint.display && this.$store.state.hintStatus.classify" :message="hint.message" @close="closeHint"></hint>
	</div>
</template>

<script>
	import API from '../../api/api';
	export default {
		name: 'Category',
		data() {
			return {
				//分類類別
				categories: [],
				//分類總數
				number: '',
				//跳出視窗警告
				alert: {
        			title: '',
        			content: '',
        			warning: "注意：刪除 E-learning 分類，會造成隸屬該分類下的 E-learning 資料失去分類，需重新編輯設定",
        			display: false,
        			inputs:['E-learning 分類', '縮寫'],
        			inputMaster: '',
        			inputSecondary: '',
        			placeholder:['請填入文字','請填入縮寫代號']
      			},
      			//loading
      			listLoading: false,
      			//是否編輯中
      			isEdit: false,
      			//目前選定的row index
      			rowIndex: 0,
      			//原始分類標題
      			originalTitle: '',
      			//原始分類代碼
      			originalCode: '',
      			//跳出hint
				hint: {
					message: '',
					display: false,
				},
				timer: null
			}
		},
		created() {
			//初始化
			this.initial();
		},
		watch: {
			categories() {
				console.log(this.categories);
			}
		},
		methods: {
			/**
			  * initial 初始化
			  * @return none
			  */   
			initial: function() {
				//取得使用者資訊
				API.getUser().then((result) => {
					if(result.status) {
						redirectLogin(result.data);
						if(!JSON.parse(result.request.response).error_msg) {
							this.showHint('取得使用者資訊錯誤!');
						} else {
							this.showHint(JSON.parse(result.request.response).error_msg);
						}
					} else {
						//update username
						this.$store.state.userName = result.name;

						//取得部門管理者清單
						API.accountInfo(this.$store.state.userName).then((response) => {
							if(response.status !== 0 && response.status !== 1) {
								redirectLogin(response.data);
							} else {
								this.$store.state.userDepId = response.depId;
								if(response.isManager === 2) {
									this.$store.state.isSystemAdminMode = true;
									this.$store.state.isBackendMode = true;
								} else if(response.isManager === 1) {
									this.$store.state.isSystemAdminMode = false;
									this.$store.state.isBackendMode = true;
								} else {
									this.$store.state.isSystemAdminMode = false;
									this.$store.state.isBackendMode = false;	
								}
							}

							if(!this.$store.state.isBackendMode) {
								this.$router.push({ path: '/table' });
								return;
							}

							this.$store.state.nowStatus = 3;
						});	
					}
				});
			},
			/**
			  * getCategories 取得主題分類列表
			  * @return none
			  */   
			getCategories: function()  {
				this.categories.length = 0;
				this.listLoading = true;
				API.getCategories().then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得 E-learning 分類錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
    				this.listLoading = false;
					} else {
						for(let i = 0 ; i < response.result.length ; i++) {
							let obj = {};
							obj = response.result[i];
							obj.isEdit = false;
							obj.index = i+1;
							this.categories.push(obj)
						}
						this.number = '共 ' + this.categories.length + ' 個分類';
						this.listLoading = false;
					}
				});
			},
			/**
			  * closeAlert close Alert 視窗
			  * @return none
			  */
			closeAlert: function() {
				this.alert.display = false;
				this.$store.state.nowCategoryStatus = 0;
			},
			/**
			  * handleCancel 取消編輯結果
			  * @param {number}    index      - row index
			  * @param {object}    row        - row content
			  * @return none
			  */   
			handleCancel: function(index, row) {
				if(this.isEdit) {
					this.isEdit = false;
					this.categories[index].isEdit = false;
					this.categories[index].title = this.originalTitle;
					this.categories[index].code = this.originalCode;
				}
			},
			/**
			  * handleSave 儲存編輯結果
			  * @param {number}    index      - row index
			  * @param {object}    row        - row content
			  * @return none
			  */
			handleSave: function(index, row) {
				if(this.isEdit) {
					API.fixCategory(this.categories[index].id, this.categories[index].title).then((response) => {
						//error
						if(response.status) {
							redirectLogin(response.data);
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('儲存編輯結果錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);
							}
						} else {
							//success
							this.isEdit = false;
							this.categories[index].isEdit = false;
							this.$store.state.isCategoryUpdated = true;
						}
					});
				}
			},
			/**
			  * handleEdit 跳出編輯畫面
			  * @param {number}    index      - row index
			  * @param {object}    row        - row content
			  * @return none
			  */   
			handleEdit: function(index, row) {
				if(!this.isEdit) {
					this.isEdit = true;
					this.categories[index].isEdit = true;
					this.originalTitle = this.categories[index].title;
					this.originalCode = this.categories[index].code;
				}
			},
			/**
			  * handleDelete 跳出刪除畫面
			  * @param {number}    index      - row index
			  * @param {object}    row        - row content
			  * @return none
			  */  
			handleDelete: function(index, row) {
				this.alert.display = true;
				this.alert.title = '刪除 E-learning 分類';
				this.$store.state.nowCategoryStatus = 1;
				this.rowIndex = index;
				this.alert.content = '您確定要刪除' + ' "' + row.title + '" ?';
			},
			/**
			  * deleteCategory 確定刪除分類
			  * @return none
			  */ 
			deleteCategory: function() {
				var deletedId = this.categories[this.rowIndex].id;
				API.deleteCategory(this.categories[this.rowIndex].id).then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('刪除分類錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						this.alert.display = false;
						this.$store.state.nowCategoryStatus = 0;
						this.getCategories();
						this.$store.state.isCategoryUpdated = true;
						const indexOfDeleted = this.$store.state.checkedCategoryListForTrend.indexOf(deletedId);
						if (indexOfDeleted !== -1) {
							this.$store.state.checkedCategoryListForTrend.splice(indexOfDeleted, 1);
						}
					}
  				});
			},
			/**
			  * handleAdd 跳出新增分類畫面
			  * @return none
			  */ 
			handleAdd() {
				if(this.isEdit) {
					return;
				}
				this.$store.state.nowCategoryStatus = 2;
				this.alert.title = '新增 E-learning 分類';
				this.alert.display = true;
			},
			/**
			  * addCategory 確定新增分類
			  * @return none
			  */ 
			addCategory() {
				API.addCategory(this.alert.inputSecondary, this.alert.inputMaster).then((response) => {
					this.alert.display = false;
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('新增分類錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						this.$store.state.nowCategoryStatus = 0;
						this.getCategories();
						this.$store.state.isCategoryUpdated = true;
    				}
  				});
			},
			/**
			  * changeMaster 變更主要輸入框的值
			  * @param {string}    valut      - input value
			  * @return none
			  */ 
			changeMaster(value) {
				this.alert.inputMaster = value;
			},
			/**
			  * changeSecondary 變更次要輸入框的值
			  * @param {string}    valut      - input value
			  * @return none
			  */ 
			changeSecondary(value) {
				this.alert.inputSecondary = value;
			},
			/**
			  * closeHint close hint 視窗
			  * @return none
			  */
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.classify = false;
				clearTimeout(this.timer);
			},
			/**
			  * showHint 
			  * @param  {string} message - message
			  * @return none
			  */
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
    			this.$store.state.showHint = true;
    			this.$store.state.hintStatus.classify = true;
    			this.timer = setTimeout(()=>{
    				if(this.$store.state.showHint) {
          				this.$store.state.showHint = false;
          				this.$store.state.hintStatus.classify = false;
          			}
        		}, this.$store.state.fadeOutTime);
			},

		},
		mounted() {
			console.log(this.categories);
			//取得主題分類列表
			this.getCategories();
		},
	}

</script>

<style lang="scss">
$font-color: #222222;
$border-color: #EEE;
$background-color: #FFFFFF;
$button-color: #2E90F4;

.category {
	.category-table {
		//position: absolute;
		//left:25%;
		//right: 25%;
		margin: 0px auto; 
		//display: table;
		//float: left;
		width: 55%;
		display: block;
		.hint {
			font-size: 15px;	
			text-align: center;
			margin-bottom: 5px;
		}
		.title-bar {
			background: $background-color;
			border-top: 1px solid $border-color;
			border-left: 1px solid $border-color;
			border-right: 1px solid $border-color;
			height: 54px;
			float: left;
			//width: 50%;
			//display: inline-block;
			.number-of-categories {
				font-size: 14px;
				color: #626874;
				line-height: 24px;
				margin-top: 15px;
				margin-left: 16px;
				float: left;
			}
			.add-btn {
	    	float: right;
	    	display: block;
	    	background: $button-color;
	    	vertical-align: middle;
				border-radius: 2px;
				border: none;
				color: #fff;
				font-size: 14px;
				height: 36px;
				margin-right: 16px;
				white-space: normal;
				margin-top: 9px;
				width: 92px;
				.add-icon {
					height: 14px;
					width: 14px;
					float: left;
				}
			}
			.add-btn:hover {
	    		background: #42A0FF;
			}	
		}	
		
		.el-table {
			font-size: 14px;
			color: $font-color;
			cursor: default;
			background: $background-color;
			.edit-icon {
				display: none;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				margin-right:5%;
				cursor: pointer;
			}
			.delete-icon {
				display: none;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				cursor: pointer;
			}
			.cancel-btn {
				display: block;
				float: right;
				margin-right:5%;
			}
			.save-btn {
				display: block;
				float: right;
			}

		}

		.el-table--enable-row-hover .el-table__body tr:hover td {
			.edit-icon {
				display: block;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				margin-right:25px;
				cursor: pointer;
			}
			.delete-icon {
				display: block;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				cursor: pointer;
			}
		}	
	}
}

</style>


// WEBPACK FOOTER //
// Category.vue?0f5df16a